/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Newsletter

define('modules/Newsletter/Newsletter',[
    'jquery',
    'global/all',
    './Newsletter.Forms'
],
    function ($, Roc, NewsletterForms) {
        'use strict';

        var Newsletter = {};
        var forms = NewsletterForms;

        Newsletter.signupFooterWidget = function (serverData) {
            $(function () {
                var newsletterTextBox = serverData.newsletterTextBox,
                    errorContainer = serverData.errorContainer,
                    newsletterButton = serverData.newsletterButton,
                    formContainer = serverData.formContainer;

                newsletterButton.click(function (e) {
                    signup(e);
                });

                newsletterTextBox.on('keypress', function (e) {
                    if (e.which === 13) {
                        signup(e);
                    }
                });

                errorContainer.html('');

                function signup(e) {
                    e.preventDefault();
                    errorContainer.html('');
                    var email = newsletterTextBox.val().toLowerCase();
                    if (/^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/.test(email)) {
                        Roc.Core.lockButton(serverData.newsletterButtonSelector);
                        $.ajax({
                            url: '/NewsletterService/Signup',
                            type: 'PUT',
                            data: JSON.stringify({ 'email': email }),
                            contentType: 'application/json',
                            dataType: 'json'
                        }).done(function (successResponse) {
                            if (successResponse.Result === true) {
                                formContainer.html('Thank you. You have been added to our list.');
                            } else if (successResponse.Result && successResponse.Message) {
                                errorContainer.html(successResponse.Message);
                            } else {
                                errorContainer.html('Internal system error');
                            }

                        }).fail(function (failResponse) {
                            if (failResponse.Message) {
                                errorContainer.html(failResponse.Message);
                            } else {
                                errorContainer.html('Internal system error');
                            }
                        }).always(function () {
                            Roc.Core.releaseLockedButton(serverData.newsletterButtonSelector);
                        });
                    } else {
                        errorContainer.html('Please enter valid email address');
                    }
                }
            });
        };

        //Previous function: newsletterRailSignupWidget(serverData) {
        Newsletter.signupRailWidget = function (serverData) {
            jQuery(function () {
                var newsletterTextBox = $(Roc.Validation.getField(forms.ManageEmailRail, 'Email').Field),
                    errorContainer = serverData.errorContainer,
                    newsletterButton = serverData.newsletterButton,
                    formContainer = serverData.formContainer;

                newsletterButton.click(function (e) {
                    signup(e);
                });

                newsletterTextBox.on('keypress', function (e) {
                    if (e.which === 13) {
                        signup(e);
                    }
                });

                errorContainer.html('');

                function signup(e) {

                    if (!Roc.Validation.validateForm(forms.ManageEmailRail)) {
                        return false;
                    }

                    e.preventDefault();
                    errorContainer.html('');
                    var email = newsletterTextBox.val().toLowerCase();

                    Roc.Core.lockButton(newsletterButton);

                    $.ajax({
                        url: '/NewsletterService/Signup',
                        type: 'PUT',
                        data: JSON.stringify({ 'email': email }),
                        contentType: 'application/json',
                        dataType: 'json'
                    }).done(function (successResponse) {
                        if (successResponse.Result === true) {
                            formContainer.html('Thank you. You have been added to our list.');
                        } else if (successResponse.Result && successResponse.Message) {
                            errorContainer.html(successResponse.Message);
                        } else {
                            errorContainer.html('Internal system error');
                        }
                    }).fail(function (failResponse) {
                        if (failResponse.Message) {
                            errorContainer.html(failResponse.Message);
                        } else {
                            errorContainer.html('Internal system error');
                        }
                    }).always(function () {
                        Roc.Core.releaseLockedButton(newsletterButton);
                    });
                }
            });
        };

        //Previous function: newsletterSignupPopupWidget(serverData) {
        Newsletter.signupPopupWidget = function (serverData) {
            $(function () {
                var newsletterTextBox = serverData.newsletterTextBox,
                    errorContainer = serverData.errorContainer,
                    successContainer = serverData.successContainer,
                    newsletterButton = serverData.newsletterButton,
                    popupContainer = serverData.popupContainer,
                    formContainer = serverData.formContainer;

                newsletterTextBox.on('keypress', function (e) {
                    if (e.which === 13) {
                        signup(e);
                    }
                });

                newsletterButton.click(function (e) {
                    signup(e);
                });

                // Open directly via API
                Roc.UI.Modal.open(popupContainer);

                errorContainer.html('');

                function signup(e) {
                    e.preventDefault();
                    errorContainer.html('');
                    var email = newsletterTextBox.val().toLowerCase();
                    if (/^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/.test(email)) {
                        Roc.Core.lockButton(newsletterButton);
                        $.ajax({
                            url: '/NewsletterService/Signup',
                            type: 'PUT',
                            data: JSON.stringify({ 'email': email }),
                            contentType: 'application/json',
                            dataType: 'json'
                        }).done(function (successResponse) {
                            if (successResponse.Result === true) {
                                formContainer.addClass('hidden');
                                successContainer.removeClass('hidden');
                            } else if (successResponse.Result && successResponse.Message) {
                                errorContainer.html(successResponse.Message);
                            } else {
                                errorContainer.html('Internal system error');
                            }
                        }).fail(function (failResponse) {
                            if (failResponse.Message) {
                                errorContainer.html(failResponse.Message);
                            } else {
                                errorContainer.html('Internal system error');
                            }
                        }).always(function () {
                            Roc.Core.releaseLockedButton(newsletterButton);
                        });
                    } else {
                        errorContainer.html('Please enter valid email address');
                    }
                }
            });
        };

        //Previous function: newsletterSubscribeWidget(serverData) {
        Newsletter.subscribeWidget = function (serverData) {
            $(function () {
                var emailTextBox = $(Roc.Validation.getField(forms.ManageEmail, 'Email').Field),
                    formContainer = serverData.formContainer,
                    errorContainer = serverData.errorContainer,
                    firstNameTextBox = $(Roc.Validation.getField(forms.ManageUser, 'First Name').Field),
                    lastNameTextBox = $(Roc.Validation.getField(forms.ManageUser, 'Last Name').Field),
                    mailingListsContainer = serverData.mailingListsContainer,
                    subscribeButton = serverData.subscribeButton,
                    cancelButton = serverData.cancelButton,
                    userNameFieldsContainer = serverData.userNameFieldsContainer,
                    emailSettingsContainer = serverData.emailSettingsContainer,
                    optOutCheckbox = serverData.optOutCheckBox,
                    autocheckAllLists = serverData.autocheckAllLists;

                if (autocheckAllLists === true) {
                    $('#mailingListsContainer li').each(function (e) {
                        $(this).find('input[type="checkbox"]').prop('checked', true);
                    });
                }

                subscribeButton.click(function (e) {
                    subscribe();
                });

                cancelButton.click(function (e) {
                    Roc.Core.lockButton(cancelButton);
                    window.location.href = document.URL;
                });

                optOutCheckbox.change(function () {
                    if ($(this).is(':checked')) {
                        userNameFieldsContainer.hide();
                        emailSettingsContainer.hide();
                    } else {
                        userNameFieldsContainer.show();
                        emailSettingsContainer.show();
                    }
                });
                optOutCheckbox.trigger("change");

                function subscribe() {

                    var email = "";

                    if ($('#managePreferencesEmailField').is('input')) {
                        email = emailTextBox.val().toLowerCase();
                    } else {
                        email = emailTextBox.html();
                        forms.ManageEmail.Validate = false;
                    }

                    if (!Roc.Validation.validateForm(forms.ManageEmail) || !Roc.Validation.validateForm(forms.ManageUser)) {
                        return false;
                    }

                    var firstName = firstNameTextBox.val().length > 0 ? firstNameTextBox.val() : firstNameTextBox.attr('placeholder');
                    var lastName = lastNameTextBox.val().length > 0 ? lastNameTextBox.val() : lastNameTextBox.attr('placeholder');

                    var subsriptionStatus = !optOutCheckbox.is(':checked');
                    var emailFormat = $('input[name=\'newsletterFormat\']:checked').val();

                    var selectedLists = [];
                    mailingListsContainer.find('input[type="checkbox"]').each(function () {
                        if ($(this).is(':checked')) {
                            selectedLists.push($(this).val());
                        }
                    });

                    var requestData = {
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        subscriptionStatus: subsriptionStatus,
                        emailFormat: emailFormat,
                        lists: selectedLists
                    }

                    Roc.Core.lockButton('#' + subscribeButton.attr('id'));

                    $.ajax({
                            url: serverData.baseUrl + '/' + serverData.newsletterSubscribeActionName,
                            type: 'POST',
                            data: JSON.stringify(requestData),
                            contentType: 'application/json',
                            dataType: 'json'
                        }).done(function (successResponse) {
                            if (successResponse && successResponse.Result) {
                                formContainer.html('Your email preferences were saved.');
                            }
                        }).fail(function (failResponse) {
                            errorContainer.html('There was a problem submitting your details please try again shortly.');
                        }).always(function () {
                            Roc.Core.releaseLockedButton('#' + subscribeButton.attr('id'));
                        });
                }
            });
        };

        Roc.Logger.debug('Newsletter.js Loaded:', Newsletter);
        return Newsletter;
    });
